import { SettingsView } from "./settings-view";
import { useSettings } from "./use-settings";

export const Settings = () => {
  const logic = useSettings();
  return <SettingsView {...logic} />;
};
